"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDictionaryCodesCollector = exports.useDictionaryCollector = exports.useDictionarySelector = void 0;
const function_1 = require("fp-ts/function");
const DictionaryProvider_1 = require("./DictionaryProvider");
const Option_1 = require("fp-ts/Option");
const useDictionarySelector = (selector) => (0, function_1.pipe)((0, DictionaryProvider_1.useDictionaryContext)(), selector);
exports.useDictionarySelector = useDictionarySelector;
const useDictionaryCollector = (collector) => (0, function_1.pipe)((0, DictionaryProvider_1.useDictionaryContext)(), collector, (0, Option_1.getOrElse)(() => []));
exports.useDictionaryCollector = useDictionaryCollector;
const useDictionaryCodesCollector = (codesCollector) => (0, function_1.pipe)((0, DictionaryProvider_1.useDictionaryContext)(), codesCollector, (0, Option_1.getOrElse)(() => []));
exports.useDictionaryCodesCollector = useDictionaryCodesCollector;
